import type { BuildingTypeKeys } from "./get_trade_measure.ts";
import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

export interface ESRCheckZipResponse{
    "region_name": string;
}


const ESRCheckZipResponseSchema : SchemaObject = {
    "region_name":'string',
}

export class ESRCheckZip extends Request<ESRCheckZipResponse>{
    override method : TRequestMethod = "POST";
    override responseSchema : Schema = ESRCheckZipResponseSchema;

    constructor (
        public sessionToken: string,
        public zip: string,
    ){
        super();
    }

    override route() : string{
        return `${BASEURL}/check_zip?sessionToken=${this.sessionToken}`;
    }
}